"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFallbackAddressIfNoAddressSet = void 0;
var _react = require("react");
var _contexts = require("../../../contexts");
var _hooks = require("../../../hooks");
var _models = require("../../../models");
/**
 * Sets location to fallback address when there is no location set after SelectPickupPointDialog is opened.
 */
const useFallbackAddressIfNoAddressSet = open => {
  const {
    mapLocation: {
      isInitialLocationDone,
      primaryAddress,
      currentLocationStatus
    }
  } = (0, _contexts.useMap)();
  const {
    viewSettings: {
      location: {
        latitude,
        longitude
      },
      zoom
    },
    setViewSettings,
    mapConfiguration
  } = (0, _hooks.usePickupPointsSearchConfiguration)();
  const {
    fallbackStartingLocation
  } = mapConfiguration ?? {};
  (0, _react.useEffect)(() => {
    if (open && !isInitialLocationDone && latitude === 0 && longitude === 0 && fallbackStartingLocation != null && primaryAddress === null && currentLocationStatus === _models.CurrentLocationStatus.Error) {
      setViewSettings({
        location: fallbackStartingLocation,
        zoom
      });
    }
  }, [currentLocationStatus, fallbackStartingLocation, isInitialLocationDone, latitude, longitude, open, primaryAddress, setViewSettings, zoom]);
};
exports.useFallbackAddressIfNoAddressSet = useFallbackAddressIfNoAddressSet;